import AEMHeadless from '@adobe/aem-headless-client-js';
import axios from 'axios';

export const S3_VERSION = 'v1';
const AEM_VERSION = 'v1';
const GRAPHQL_ENDPOINT = 'dcxconnex-loyalty';

let aemClient = null;

const getAemClient = () => {
    if (!aemClient) {
        aemClient = new AEMHeadless({});
    }
    return aemClient;
};

const getAemEnvByReactEnv = (reactEnv) => {
    if (reactEnv === 'local') return 'dev';
    return reactEnv;
};

const getS3Path = (marketName, relativePath) => {
    return `/aemcontent/${marketName}/${S3_VERSION}/${relativePath}`;
};

const getAemResponse = (rawResponse) => {
    const response = rawResponse?.data || {};
    const mainKey = Object.keys(response)[0];
    return response[mainKey]?.item;
};

const initMarketContent = async (marketName, languageCode) => {
    try {
        let result;

        if (import.meta.env.VITE_IS_AEM_SERVER === 'true') {
            const path = `/content/dam/${GRAPHQL_ENDPOINT}/${marketName}/${AEM_VERSION}/${getAemEnvByReactEnv(import.meta.env.VITE_ENV)}/global/${languageCode}/market-content`;

            result = await getAemClient().runPersistedQuery(`${GRAPHQL_ENDPOINT}/get-market-content`, {
                path,
            });
        } else {
            const s3Path = getS3Path(marketName, `${languageCode}/content.json`);
            const request = await axios.get(s3Path);
            result = request?.data;
        }

        const marketContent = getAemResponse(result);

        if (!marketContent)
            throw new Error(
                `Market content is not initialized for market: ${marketName} and language: ${languageCode}`
            );

        return marketContent;
    } catch (e) {
        console.error('initMarketContent error:', e);
        throw e;
    }
};

export default {
    initMarketContent,
};
